import {
  clearCompleted,
  filterActive,
  filterAll,
  filterCompleted,
  getCheckIcons,
  getCrossIcons,
  themeToggler,
  todoForm,
  todoInput,
  todoList,
  todoListItems,
} from "./elements";
import {
  addNewTodo,
  getData,
  saveData,
  toggleTheme,
  updateTodoList,
} from "./utils";

const assignKeyDownEvent = (e) => {
  if (e.key === "Enter" || e.key === " ") e.currentTarget.click();
};

themeToggler.addEventListener("click", () => {
  const isDarkTheme = JSON.parse(getData("isDarkTheme"));
  saveData("isDarkTheme", !isDarkTheme);
  toggleTheme();
});

todoForm.addEventListener("submit", (e) => {
  e.preventDefault();
  let tasksList = JSON.parse(getData("tasksList")) || [];
  let activeCount = JSON.parse(getData("activeCount")) || 0;

  const task = {
    id: crypto.randomUUID(),
    value: todoInput.value,
    isCompleted: false,
    hide: false,
    isDisplayAll: true,
    order: tasksList.length,
  };

  const updatedList = addNewTodo(task, tasksList);

  saveData("activeCount", activeCount + 1);
  updateTodoList(updatedList);

  todoInput.value = "";
  filterAll.click();
});

const completeEvents = () => {
  getCheckIcons().forEach((icon) => {
    icon.addEventListener("click", (e) => {
      let activeCount = JSON.parse(getData("activeCount"));
      let completedCount = JSON.parse(getData("completedCount"));
      const tasksList = JSON.parse(getData("tasksList"));

      const targetTask = tasksList.find(
        (task) => task.id === e.currentTarget.dataset.id
      );

      if (targetTask.isCompleted) {
        saveData("activeCount", activeCount + 1);
        saveData("completedCount", completedCount - 1);
      } else {
        saveData("activeCount", activeCount - 1);
        saveData("completedCount", completedCount + 1);
      }

      targetTask.isCompleted = !targetTask.isCompleted;
      targetTask.hide = targetTask.isDisplayAll
        ? targetTask.hide
        : !targetTask.hide;

      saveData("tasksList", tasksList);
      updateTodoList(tasksList);
    });

    icon.addEventListener("keydown", (e) => assignKeyDownEvent(e));
  });
};

const deleteEvents = () => {
  getCrossIcons().forEach((icon) => {
    icon.addEventListener("click", (e) => {
      let activeCount = JSON.parse(getData("activeCount"));
      let completedCount = JSON.parse(getData("completedCount"));
      let tasksList = JSON.parse(getData("tasksList"));

      const targetTask = tasksList.find(
        (task) => task.id === e.currentTarget.dataset.id
      );

      tasksList = tasksList.filter(
        (task) => task.id !== e.currentTarget.dataset.id
      );

      !targetTask.isCompleted && saveData("activeCount", activeCount - 1);
      targetTask.isCompleted && saveData("completedCount", completedCount - 1);

      saveData("tasksList", tasksList);
      updateTodoList(tasksList);
    });

    icon.addEventListener("keydown", (e) => assignKeyDownEvent(e));
  });
};

const reorderList = () => {
  const listItems = [...todoListItems()];
  const tasksList = JSON.parse(getData("tasksList")) || [];

  const reorderedTasksList = tasksList.map((task) => {
    for (let i = 0; i < listItems.length; i++) {
      if (listItems[i].id === task.id) {
        return { ...task, order: i };
      }
    }
  });

  saveData("tasksList", reorderedTasksList);
};

const getAfterElemennt = (parent, yPosition) => {
  const draggables = [
    ...parent.querySelectorAll(".todo__item:not(.todo__item--isDragging)"),
  ];

  const targetElement = draggables.reduce(
    (closest, draggable) => {
      const box = draggable.getBoundingClientRect();
      const offset = yPosition - box.top - box.height / 2;

      if (offset < 0 && offset > closest.offset) {
        return { offset, element: draggable };
      } else {
        return closest;
      }
    },
    { offset: Number.NEGATIVE_INFINITY }
  );

  return targetElement.element || null;
};

const handleDragStart = (e) => {
  e.currentTarget.classList.add("todo__item--isDragging");
};

const handleDragEnd = (e) => {
  e.currentTarget.classList.remove("todo__item--isDragging");
  reorderList();
};

const handleDragMove = (e) => {
  const dragging = todoList.querySelector(".todo__item--isDragging");
  let yPosition;

  if (e.type === "dragover") {
    yPosition = e.clientY;
  } else if (e.type === "touchmove") {
    yPosition = e.touches[0].clientY;
  }

  const afterElement = getAfterElemennt(todoList, yPosition);

  if (afterElement === null) {
    todoList.appendChild(dragging);
  } else {
    todoList.insertBefore(dragging, afterElement);
  }
};

const assignDragEvents = () => {
  todoList.addEventListener("dragover", (e) => handleDragMove(e));

  todoListItems().forEach((item) => {
    item.addEventListener("dragstart", (e) => handleDragStart(e));

    item.addEventListener("dragend", (e) => handleDragEnd(e));
  });
};

// drag and drop for touch screens
const assignTouchEvents = () => {
  todoList.addEventListener("touchmove", (e) => handleDragMove(e), {
    passive: true,
  });

  todoListItems().forEach((item) => {
    item.addEventListener("touchstart", (e) => handleDragStart(e), {
      passive: true,
    });

    item.addEventListener("touchend", (e) => handleDragEnd(e));
  });
};

export const initListEvetns = () => {
  completeEvents();
  deleteEvents();
  assignDragEvents();
  assignTouchEvents();
};

filterAll.addEventListener("click", () => {
  filterAll.classList.add("filter--isActive");
  filterActive.classList.remove("filter--isActive");
  filterCompleted.classList.remove("filter--isActive");

  let tasksList = JSON.parse(getData("tasksList"));

  tasksList = tasksList.map((task) => ({
    ...task,
    hide: false,
    isDisplayAll: true,
  }));

  saveData("tasksList", tasksList);
  saveData("currentDisplay", "all");
  updateTodoList(tasksList);
});
filterAll.addEventListener("keydown", (e) => assignKeyDownEvent(e));

filterActive.addEventListener("click", () => {
  filterActive.classList.add("filter--isActive");
  filterAll.classList.remove("filter--isActive");
  filterCompleted.classList.remove("filter--isActive");

  let tasksList = JSON.parse(getData("tasksList"));

  tasksList = tasksList.map((task) => {
    if (task.isCompleted) {
      return { ...task, hide: true, isDisplayAll: false };
    } else {
      return { ...task, hide: false, isDisplayAll: false };
    }
  });

  saveData("tasksList", tasksList);
  saveData("currentDisplay", "active");
  updateTodoList(tasksList);
});
filterActive.addEventListener("keydown", (e) => assignKeyDownEvent(e));

filterCompleted.addEventListener("click", () => {
  filterCompleted.classList.add("filter--isActive");
  filterAll.classList.remove("filter--isActive");
  filterActive.classList.remove("filter--isActive");

  let tasksList = JSON.parse(getData("tasksList"));

  tasksList = tasksList.map((task) => {
    if (task.isCompleted) {
      return { ...task, hide: false, isDisplayAll: false };
    } else {
      return { ...task, hide: true, isDisplayAll: false };
    }
  });

  saveData("tasksList", tasksList);
  saveData("currentDisplay", "completed");
  updateTodoList(tasksList);
});
filterCompleted.addEventListener("keydown", (e) => assignKeyDownEvent(e));

clearCompleted.addEventListener("click", () => {
  let tasksList = JSON.parse(getData("tasksList"));
  tasksList = tasksList.filter((task) => !task.isCompleted);

  saveData("tasksList", tasksList);
  saveData("completedCount", 0);
  filterAll.click();
});
clearCompleted.addEventListener("keydown", (e) => assignKeyDownEvent(e));
